import {Injectable} from '@angular/core';

import {Table, TableCellProps} from './table-properties';

@Injectable({
  providedIn: 'root'
})
export class TableDataExportUtilsService {
  public findRowSpanningCells(matrix: TableCellProps[][]) {
    return this.findSpanningCells(matrix, false, true);
  }

  public findColSpanningCells(matrix: TableCellProps[][]) {
    return this.findSpanningCells(matrix, true, false);
  }

  public findAllSpanningCells(matrix: TableCellProps[][]) {
    return this.findSpanningCells(matrix);
  }

  public getColumnCount(tables: Table[]): number {
    let longestColumnLength = 0;
    for (const matrix of tables) {
      for (const row of matrix) {
        if (row.length > longestColumnLength) {
          longestColumnLength = row.length;
        }
      }
    }
    return longestColumnLength;
  }

  private findSpanningCells(
    matrix: TableCellProps[][],
    findColspan = true,
    findRowspan = true
  ) {
    const rowSpanCellsMatrix: {
      rowIndex: number;
      colIndex: number;
      rowspan: number;
      colspan: number;
    }[] = [];
    for (let rowIndex = 0; rowIndex < matrix.length; rowIndex++) {
      const row = matrix[rowIndex];
      for (let colIndex = 0; colIndex < row.length; colIndex++) {
        const cell = row[colIndex];
        const hasRowspan = cell.rowspan > 1;
        const hasColspan = cell.colspan > 1;

        if ((findRowspan && hasRowspan) || (findColspan && hasColspan)) {
          rowSpanCellsMatrix.push({
            rowIndex,
            colIndex,
            rowspan: cell.rowspan,
            colspan: cell.colspan
          });
        }
      }
    }
    return rowSpanCellsMatrix;
  }
}
